'use strict';

angular.module('shiftTraderApp')
  .service('TimeService', ['$rootScope', 'Session', function ($rootScope, Session) {
    var theTz = Session.getTimezone();
    var startOfWeekDay = Session.getStartOfWeekDay();
    var workDayStartHour = Session.getWorkDayStartHour();
    var fiscalYearStartFromDB = '01-01';

    var setStartOfWeekDay = function(x) {
      startOfWeekDay = x;
      return startOfWeekDay;
    };

    var getDateForBeginningOfDayFromMomentWithOrgSetting = function(mmnt) {
      var x = getBeginningOfDayFromDateWithOrgSetting(mmnt);
      var dtOnMmnt = new Date(mmnt.year(), mmnt.month(), mmnt.date(), 0, 0, 0, 0);
      var offsetDiffInMinutes = dtOnMmnt.getTimezoneOffset() - x.zone();

      if (offsetDiffInMinutes !== 0) {
        x = x.add(offsetDiffInMinutes / 60.0, 'hours');
      }

      return x.toDate();
    };

    var getBeginningOfDayFromDate = function(dt) {
      theTz = Session.getTimezone();
      var valOther = moment(dt).hours(moment(dt).tz(theTz).startOf('day').zone()/60.0).tz(theTz).minutes(0).seconds(0).milliseconds(0).hours(0);
      var valOtherZone = valOther.zone();
      valOther = valOther.add(valOtherZone - moment(dt).tz(theTz).zone(), 'minutes');
      return valOther;
      //return moment.utc(dt).hours(moment.utc(dt).tz(theTz).zone()/60.0).tz(theTz).minutes(0).seconds(0).milliseconds(0);
    };

    var getBeginningOfDayFromDateWithOrgSetting = function(dt) {
      var temp = getBeginningOfDayFromDate(dt);
      workDayStartHour = Session.getWorkDayStartHour();
      if (workDayStartHour && workDayStartHour > 0) {
        return moment(temp).add(workDayStartHour, 'hours');
      } else {
        return temp;
      }
    };

    var getNowInStoreTime = function() {
      return moment.utc().tz(Session.getTimezone());
    };

    var getDayTwixFromDate = function(dt) {
      var temp = getBeginningOfDayFromDate(dt);
      return temp.twix(moment(temp).add(24,'hours'));
    };

    var getWeekTwixFromMoment = function(mmnt, numPreDays, numPostDays) {
      startOfWeekDay = Session.getStartOfWeekDay();
      numPreDays = _.isUndefined(numPreDays) ? 0 : numPreDays;
      numPostDays = _.isUndefined(numPostDays) ? 0 :numPostDays;
      var offsetAdjust = 0;
      var basis = getBeginningOfDayFromDate(mmnt);
      var basisDayOfWeek = basis.day();

      if (basisDayOfWeek < startOfWeekDay) {
        offsetAdjust = 7;
      }
      //console.log(moment(basis).subtract(basisDayOfWeek - startOfWeekDay + numPreDays + offsetAdjust, 'days').format());
      return moment(basis).subtract(basisDayOfWeek - startOfWeekDay + numPreDays + offsetAdjust, 'days')
        .twix(moment(basis).add(startOfWeekDay - basisDayOfWeek + numPostDays + 7 - offsetAdjust, 'days'));
    };

    var getWorkWeekNumberFromMoment = function(mmnt) {
      var firstWeekStart, dayDiff, weekNum;
      var nowYear = getNowInStoreTime().year();
      var fiscalYearStartDate = getDayTwixFromDate(moment.utc(nowYear + '-' + fiscalYearStartFromDB)).start;
      while (mmnt.isBefore(fiscalYearStartDate)) {
        fiscalYearStartDate = moment(fiscalYearStartDate).subtract(1, 'years');
      }

      if (startOfWeekDay < fiscalYearStartDate.day()) {
        firstWeekStart = fiscalYearStartDate.add(7 - fiscalYearStartDate.day() + startOfWeekDay, 'days');
        dayDiff = Math.ceil(firstWeekStart.twix(mmnt).length('hours') / 24.0 - 0.1);
        if (dayDiff < 0) {
          weekNum = 1;
        } else {
          weekNum = 2 + Math.floor(dayDiff / 7.0);
        }
      } else {
        firstWeekStart = fiscalYearStartDate.subtract(7 - (startOfWeekDay - fiscalYearStartDate.day()), 'days');
        dayDiff = firstWeekStart.twix(mmnt).length('days');
        weekNum = Math.floor(dayDiff / 7.0) + 1;
      }
      //console.log('dayDiff: ' + dayDiff + ';   weekNum: ' + weekNum);
      return weekNum;
    };

    var minutesToTimeString = function(minutes, includeMeridian, useMarkup) {
      //convert a number of minutes from 0 to 48hrs worth of minutes to a pretty time
      var pad = function(x) {
        if (x < 10) {
          return '0' + x;
        } else {
          return x;
        }
      };

      var renderMinIfNeeded = function(iMin) {
        if (iMin!== 0) {
          return ':' + pad(iMin);
        } else {
          return '';
        }
      };

      var renderText = function(hours, iMin, meridian) {
        if (useMarkup) {
          var sMin = renderMinIfNeeded(iMin);
          return '<span class="min_to_time_hours">' + hours + '</span>' +
            ((sMin !== '') ? ('<span class="min_to_time_minutes">' + renderMinIfNeeded(iMin) + '</span>') : '') +
            ((meridian !== '') ? ('<span class="min_to_time_meridian">' + meridian + '</span>') : '');
        } else {
          return hours + renderMinIfNeeded(iMin) + (includeMeridian ? meridian : '');
        }
      };

      var hours = Math.floor(minutes / 60.0);
      var min = minutes - hours * 60;

      if (minutes < 720) {
        if (minutes < 60) {
          hours = 12;
        }
        return renderText(hours, min, 'a');
      } else if (minutes >= 720 && minutes < 1440) {
        if (hours > 12) {
          return renderText(hours - 12, min, 'p');
        } else {
          return renderText(12, min, 'p');
        }
      } else if (minutes >= 1440) {
        // if the time is into the next day
        if (hours > 36) {
          // past noon on the next day
          return renderText(hours - 36, min, 'p');
        } else if (hours > 24) {
          // before noon on the next day
          return renderText(hours - 24, min, 'a');
        } else {
          return renderText(12, min, 'a');
        }
      }
    };


    var minimalMomentFormat = function(mmnt, showMeridian, useMarkup) {
      var min = mmnt.format('mm');
      var hr = mmnt.format('h');

      if (useMarkup) {
        var temp = '<div class="moment_hour">' + hr + '</div>';

        if ( min > 0) {
          temp +=  '<div class="moment_hour_min_sep"></div>' +
              '<div class="moment_min">' + min + '</div>';
        }

        if (showMeridian) {
          temp += '<div class="moment_meridian">' + mmnt.format('a')[0] + '</div>';
        }
        return temp;

      } else {
        return hr + (min > 0 ? (':' + min) : '') + (showMeridian ? mmnt.format('a')[0] : '');
      }
    };

    var minimalTwixFormat = function(twix, showMeridian, useMarkup, seperator) {
      var sep = _.isUndefined(seperator) ? '-' : seperator;
      if (useMarkup) {
        return minimalMomentFormat(twix.start, showMeridian, true) + '<div class="twix_range_seperator">' + sep + '</div>' + minimalMomentFormat(twix.end, showMeridian, true);
      } else {
        return minimalMomentFormat(twix.start, showMeridian, false) + sep + minimalMomentFormat(twix.end, showMeridian, false);
      }
    };

    var minimalIntervalTimeFormat = function(twix, combineWord, startDateFmt) {
      // for use with day off requests
      var str = '';
      var htmlStr = '';
      startDateFmt = startDateFmt || 'MMM D';

      if (!combineWord) {
        combineWord = 'through';
      }

      var isMidnightToMidnight = twix.start.hour() === 0 && twix.end.hour() === 0;
      var isLongerThanDay = (Math.abs(twix.length('minutes') / 60.0)) > 24.0;
      var isOnTwoDifferentDates = twix.start.dayOfYear() !== twix.end.dayOfYear() && (Math.abs(twix.length('minutes') / 60.0)) >= 24 && twix.end.hour() !== 0;
      var isAcrossMultipleMonths = twix.start.month() !== twix.end.month();

      var addEndTime = twix.end.hour() !== 0 || twix.end.minute() !== 0;
      var addStartTime = (twix.start.hour() !== 0 || twix.start.minute() !== 0) || (addEndTime && !isOnTwoDifferentDates) ;
      var addEndDate = isLongerThanDay || isOnTwoDifferentDates;
      var needPostStartSpace = true;

//        console.log(twix.format());
//        console.log(twix);
//        console.log('isLongerThanDay', isLongerThanDay);
//        console.log('isOnTwoDifferentDates', isOnTwoDifferentDates);
//        console.log('isAcrossMultipleMonths', isAcrossMultipleMonths);
//        console.log('addStartTime', addStartTime);
//        console.log('addEndTime', addEndTime);
//        console.log('addEndDate', addEndDate);

      htmlStr += '<span class="mif_start_date">' + twix.start.format(startDateFmt) + '</span>';
      str += twix.start.format(startDateFmt);

      if (addStartTime || addEndTime) {
        str += ' ' + minimalMomentFormat(twix.start, true);
        htmlStr += ' <span class="mif_start_time">' + minimalMomentFormat(twix.start, true) + '</span>';
      }

      if ((!isLongerThanDay && !isOnTwoDifferentDates && addEndTime) || (addEndDate && !isAcrossMultipleMonths && !addEndTime && !addStartTime)) {
        str += '-';
        htmlStr += '<span class="mif_dash">-</span>';
        needPostStartSpace = false;
      } else if (addEndDate || addEndTime) {
        str += ' ' + combineWord;
        htmlStr += ' <span class="mif_combine_word">' + combineWord + '</span>';
      }

      //if !addEndTime then use the day before for the end date, notating THROUGH instead of a day past
      var endDate;
      if (addEndTime) {
        endDate = twix.end;
      } else {
        endDate = moment(twix.end).subtract(22, 'hours');
      }

      if (addEndDate) {
        if (isAcrossMultipleMonths || addEndTime || addStartTime) {
          str += ' ' + endDate.format('MMM D');
          htmlStr += ' <span class="mif_end_date">' + endDate.format('MMM D') + '</span>';
        } else {
          if (needPostStartSpace) {
            str += ' ';
          }
          str += endDate.format('D');
          htmlStr += '<span class="mif_end_date">' + endDate.format('D') + '</span>';
        }
      }

      if (addEndTime) {
        if (needPostStartSpace) {
          str += ' ';
          htmlStr += ' ';
        }
        str += minimalMomentFormat(twix.end, true);
        htmlStr += '<span class="mif_end_time">' + minimalMomentFormat(twix.end, true) + '</span>';
      }

      var ret = {
        strings: {
          interval: str,
          htmlInterval: htmlStr,
          startDate: twix.start.format('MMM D'),
          endDate: endDate.format('MMM D'),
          startTime: minimalMomentFormat(twix.start, true),
          endTime: minimalMomentFormat(twix.end, true)
        },
        needEndDate: addEndDate,
        needEndTime: addEndTime,
        needStartTime: addStartTime
      };
      return ret;
    };

    return {
      getBeginningOfDayFromDate: getBeginningOfDayFromDate,
      getBeginningOfDayFromDateWithOrgSetting: getBeginningOfDayFromDateWithOrgSetting,
      getDateForBeginningOfDayFromMomentWithOrgSetting: getDateForBeginningOfDayFromMomentWithOrgSetting,
      getNowInStoreTime: getNowInStoreTime,
      getDayTwixFromDate: getDayTwixFromDate,
      getWeekTwixFromMoment: getWeekTwixFromMoment,
      getWorkWeekNumberFromMoment: getWorkWeekNumberFromMoment,
      setStartOfWeekDay: setStartOfWeekDay,
      minutesToTimeString: minutesToTimeString,
      minimalMomentFormat: minimalMomentFormat,
      minimalTwixFormat: minimalTwixFormat,
      minimalIntervalTimeFormat: minimalIntervalTimeFormat
    };

  }]);
